import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { isAuthenticated } from '../../../store/selectors/AuthSelectors';
import '../FeaturesSection/FeaturesSection.css';
import './ProductModuleContent.css';

const ProductModuleContent = ({ sixBoxes, features, cta, afterBoxes }) => {
  const loggedIn = useSelector(isAuthenticated);

  return (
    <>
      <section className="product-module-six-boxes">
        <div className="container">
          <div className="features-grid">
            {sixBoxes.map((box) => (
              <div key={box.title} className="feature-card">
                <h3>{box.title}</h3>
                <p>{box.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {afterBoxes}

      <section className="product-module-features">
        <div className="container">
          <h2 className="product-module-features-title">Features</h2>
          <ul className="product-module-features-list">
            {features.map((feature) => (
              <li key={feature}>{feature}</li>
            ))}
          </ul>
          {cta ? (
            <div className="section-cta product-module-features-cta">
              <Link
                to={loggedIn ? cta.loggedInTo : cta.to}
                className="subscribe-btn"
              >
                {cta.label}
              </Link>
            </div>
          ) : null}
        </div>
      </section>
    </>
  );
};

export default ProductModuleContent;
